import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
// @ts-ignore
import { fetch as whatWGFetch } from 'whatwg-fetch';

/**
 * Use native browser implementation if it supports aborting
 * @link https://github.com/github/fetch#aborting-requests
 */
export const fetch: typeof window.fetch =
  'signal' in new Request('') ? window.fetch : whatWGFetch;

/**
 * @link https://github.com/mo/abortcontroller-polyfill#using-it-along-with-create-react-app
 */
export const { AbortController } = window;

export enum HttpMethods {
  GET = 'GET',
  DELETE = 'DELETE',
  POST = 'POST',
  PUT = 'PUT',
}

export default {
  fetch,
  AbortController,
  HttpMethods,
};
